enum DocumentStatusType {
	UNKNOWN = "Unknown",
	IN_PROGRESS = "InProgress",
	DECLINED = "Declined",
	NOT_REQUIRED = "NotRequired",
	ACCEPTED = "Accepted"
}

export default DocumentStatusType;
